exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Legend__legend__1vqIO {\n  bottom: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: calc(100% - 226px);\n  position: absolute;\n  right: 20px;\n}\n\n.dmb-web__Legend__legendSplit__iVJSw {\n  bottom: 270px;\n  max-height: calc(100% - 346px);\n}\n", ""]);

// exports
exports.locals = {
	"legend": "dmb-web__Legend__legend__1vqIO",
	"legendSplit": "dmb-web__Legend__legendSplit__iVJSw"
};